// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.okATSrrfbVFhs11Gmi4x{display:grid;grid-template-columns:140px auto}.okATSrrfbVFhs11Gmi4x._MUnxbu2xCZTGY0scokL{row-gap:8px}`, "",{"version":3,"sources":["webpack://./src/shared/ui/Modal/ui/ModalInfoBlock/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,gCAAA,CAEA,2CACE,WAAA","sourcesContent":[".grid {\n  display: grid;\n  grid-template-columns: 140px auto;\n\n  &.gridGap {\n    row-gap: 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"grid": `okATSrrfbVFhs11Gmi4x`,
	"gridGap": `_MUnxbu2xCZTGY0scokL`
};
export default ___CSS_LOADER_EXPORT___;
